import { findErrorsInModel } from '../utils/validation/findErrorsInModel';
import { validationMessages } from '../constants/validation/contactDetails';
import { isValidInput } from '../utils/validation/isValidInput';

function getSchema() {
  return {
    emailAddress: (value) => {
      const MIN_EMAIL_LENGTH = 6;
      const MAX_EMAIL_LENGTH = 70;
      return (
        (value === '' && validationMessages.emailAddress) ||
        (value.length < MIN_EMAIL_LENGTH && validationMessages.emailAddress) ||
        (value.length > MAX_EMAIL_LENGTH && validationMessages.emailAddress) ||
        (!isValidInput(value, 'Email') && validationMessages.emailAddress)
      );
    },
    /**
     * @hotfix
     * Removed "manual" length validation in favour of some stricted regex checks, which enforce the
     * correct length of phone numbers. Look for this in `isValidInput.js`
     */
    workPhoneNumber: (value) =>
      value !== '' && !isValidInput(value, 'Phone') && validationMessages.workPhoneNumber,
    homePhoneNumber: (value) =>
      value !== '' && !isValidInput(value, 'Phone') && validationMessages.homePhoneNumber,
    mobileNumber: (value) =>
      /* home and work numbers are optional, but we need a mobile number */
      (value === '' && validationMessages.mobileNumber) ||
      (value !== '' && !isValidInput(value, 'Mobile') && validationMessages.mobileNumber),
    preferredMethod: (value) => value === '' && validationMessages.preferredMethod
  };
}
export const validateModel = (model) => {
  const schema = getSchema();

  const foundErrors = findErrorsInModel(model, schema);

  return foundErrors;
};

export const validateFormField = (field, value) => {
  const schema = getSchema();
  return schema[field] && schema[field](value);
};
